import API from "../../../shared/modules/API";
import {Link} from "react-router-dom";
import ProductPanel from "./ProductPanel";
import PropTypes from "prop-types";
import React from "react";
import SharedPropTypes from "../../Swap/modules/SharedPropTypes";
import {connect} from "react-redux";

class WishlistGrid extends React.Component {
  static propTypes = {
    "addWishListRequest": PropTypes.func.isRequired,
    "allRingSizes": PropTypes.array.isRequired,
    "customerRequests": PropTypes.object.isRequired,
    "eligibleForFineJewelry": PropTypes.bool.isRequired,
    "filtering": PropTypes.bool,
    "handleShowSwapModal": PropTypes.func,
    "lazyLoadingNow": PropTypes.bool,
    "onSelectSwap": PropTypes.func,
    "previewSwapping": PropTypes.bool,
    "productDescriptors": SharedPropTypes.productDescriptors,
    "productOrdering": PropTypes.array.isRequired,
    "productPanelClass": PropTypes.string,
    "products": PropTypes.object.isRequired,
    "removeWishListRequest": PropTypes.func.isRequired,
    "requestsFetched": PropTypes.bool,
    "setNotificationType": PropTypes.func.isRequired,
    "showClearancePrice": PropTypes.bool,
    "showComingSoon": PropTypes.bool,
    "showModal": PropTypes.func,
    "showProductName": PropTypes.bool,
    "showRetailPrice": PropTypes.bool,
    "showTags": PropTypes.bool,
    "showWishlistStars": PropTypes.bool,
    "updateState": PropTypes.func.isRequired,
    "useModal": PropTypes.bool
  };

  static defaultProps = {
    "customerRequests": {},
    "eligibleForFineJewelry": false,
    "filtering": false,
    "handleShowSwapModal": null,
    "lazyLoadingNow": false,
    "onSelectSwap": null,
    "previewSwapping": false,
    "productDescriptors": null,
    "productPanelClass": "",
    "requestsFetched": false,
    "showClearancePrice": false,
    "showComingSoon": false,
    "showModal": null,
    "showProductName": false,
    "showRetailPrice": false,
    "showTags": false,
    "showWishlistStars": false,
    "useModal": false
  };

  componentDidMount = () => {
    const {previewSwapping} = this.props;
    if (previewSwapping) {
      this.sortProductsByWishlist();
    }
  }

  getRingSizes = (id) => {
    const {"products": {[id]: product}, customerRequests, requestsFetched} = this.props;
    const {productDescriptor} = product;
    const {
      "details":
        {
          "kind_name": kindName,
          "natural_stone_color_groups": naturalStoneColorGroups,
          "metal_name": metalName,
          "product_name": productName
        }
    } = productDescriptor;
    const isAnArray = Array.isArray(naturalStoneColorGroups[metalName]);
    const isObject = typeof naturalStoneColorGroups === "object";
    const isRing = kindName === "Ring";

    if (isRing && isObject && isAnArray && requestsFetched) {
      return naturalStoneColorGroups[metalName].
        filter(innerProduct => innerProduct.product_name === productName).
        sort((firstProduct, secondProduct) => firstProduct.ring_size - secondProduct.ring_size).
        map(innerProduct => ({
          ...innerProduct,
          "wishlisted": customerRequests[innerProduct.id] &&
            customerRequests[innerProduct.id].statuses.includes("pending")
        }));
    }
    return [];
  }

  sortProductsByWishlist = () => {
    const {
      customerRequests,
      productOrdering,
      requestsFetched
    } = this.props;

    return productOrdering.map((id) => {
      const wishlisted = requestsFetched && customerRequests[id] && customerRequests[id].statuses.includes("pending");
      return (
        {
          id,
          wishlisted
        }
      );
    }).sort((prev, next) => next.wishlisted - prev.wishlisted).map(item => item.id);
  }

  renderWishlist = () => {
    const {
      eligibleForFineJewelry,
      previewSwapping,
      productOrdering,
      productPanelClass,
      showClearancePrice,
      showComingSoon,
      showProductName,
      showRetailPrice,
      showTags,
      showWishlistStars,
      useModal
    } = this.props;

    if (productOrdering.length === 0) {
      return (
        <div className="empty-message color-dark-grey">
          <div className="no-search-results-icon" />
          <h2 className="sub-header">
            No matching styles.
          </h2>
          <div>
            Oops, it looks like we couldn&apos;t find any pieces that match your search.
          </div>
        </div>
      );
    }

    const {addToCartFromGrid} = document.documentElement.dataset;

    return productOrdering.map((id, index) => {
      const {
        addWishListRequest,
        allRingSizes,
        customerRequests,
        handleShowSwapModal,
        onSelectSwap,
        productDescriptors,
        "products": {[id]: product},
        removeWishListRequest,
        requestsFetched,
        setNotificationType
      } = this.props;
      const wishlisted = requestsFetched && customerRequests[id] && customerRequests[id].statuses.includes("pending");

      return (
        <ProductPanel
          {...product}
          addToCartFromGrid={addToCartFromGrid && addToCartFromGrid === "active"}
          addWishListRequest={addWishListRequest}
          allRingSizes={allRingSizes}
          customerId={API.CUSTOMER_ID}
          eligibleForFineJewelry={eligibleForFineJewelry}
          handleShowSwapModal={handleShowSwapModal}
          // eslint-disable-next-line react/no-array-index-key
          key={String(id) + index}
          onSelectSwap={onSelectSwap}
          previewSwapping={previewSwapping}
          productDescriptors={productDescriptors}
          productPanelClass={productPanelClass}
          removeWishListRequest={removeWishListRequest}
          ringSizes={this.getRingSizes(id)}
          setNotificationType={setNotificationType}
          showClearancePrice={showClearancePrice}
          showComingSoon={showComingSoon}
          showModal={this.showModal}
          showProductName={showProductName}
          showRetailPrice={showRetailPrice}
          showTags={showTags}
          showWishlistStars={showWishlistStars}
          useModal={useModal}
          wishlisted={wishlisted || false}
        />);
    });
  };

  showModal = (id) => {
    const {showModal} = this.props;
    showModal(id);
  };

  render () {
    const {filtering, lazyLoadingNow, previewSwapping} = this.props;

    return (
      <div>
        <div className="row wish-list-grid text-center filters-grid">
          {!filtering &&
            <div className="grid">
              {this.renderWishlist()}
            </div>}
          {lazyLoadingNow &&
            <img
              className="loading-jewelry mt16 mb32"
              src="https://karat-herokuapp-com.freetls.fastly.net/s3media/site/wish_list/loading-jewelry-sparkle.gif"
            />}
          {previewSwapping &&
            <div className="bottom-button mb40">
              <Link
                className="btn btn-primary return-to-set" // eslint-disable-line
                to="/account/preview_next_set"
              >
                Return To My Set
              </Link>
            </div>}
        </div>

      </div>
    );
  }
}

const mapStoreToProps = store => ({"customerRequests": store.customerRequests});

export default connect(mapStoreToProps)(WishlistGrid);
